/**
 * Почему у версии в этом состоянии содержание не меняется — ПО СОСТОЯНИЮ, а не одной фразой про
 * ключ. Раньше полосы файла и картинки говорили «выпущен ключ публикации — снимите пост со
 * слота» про любую неправимую версию, и у заменённой, опубликованной или удалённой версии (ни
 * ключа, ни слота) это была ложь с невыполнимым советом (ревью 19.09.2026, ui-11). Выход назван
 * там, где он есть: снятие со слота — переход 14, «Вернуть в работу» — 23 и 24 (`FailedPanel`).
 *
 * Один словарь на все полосы под постом: причина — свойство версии, а не того, что в неё кладут.
 * Меняется только дополнение («файл», «картинку», «мнение»).
 */

import { DRAFT_STATE_LABEL_RU, type DraftState } from '@smm/contracts';

/** Что меняют — в винительном падеже: «…и файл снова можно будет менять». */
export interface LockObject {
  readonly acc: string;
}

export const FILE_OBJECT: LockObject = { acc: 'файл' };
export const PICTURE_OBJECT: LockObject = { acc: 'картинку' };
/** Мнение автора канала (полоса «Мнение автора», 2026-11-02). */
export const OPINION_OBJECT: LockObject = { acc: 'мнение' };

const capital = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

const REASON: Readonly<Partial<Record<DraftState, (what: LockObject) => string>>> = {
  scheduled: (w) =>
    `на её содержание выпущен ключ публикации. Снимите пост со слота — и ${w.acc} снова можно будет менять`,
  publishing: () => 'пост прямо сейчас уходит в канал',
  needs_manual_check: () => 'неизвестно, вышел ли пост. Сначала отметьте, есть ли он в канале',
  failed: (w) =>
    `публикация не состоялась. Верните версию в работу — и ${w.acc} снова можно будет менять`,
  expired: (w) =>
    `публикация не состоялась. Верните версию в работу — и ${w.acc} снова можно будет менять`,
  published: () => 'пост уже в канале',
  retracted: () => 'пост отозван из канала, действий над этой версией больше нет',
  discarded: () => 'пост удалён, действий над ним больше нет',
  superseded: (w) => `её заменила следующая версия. ${capital(w.acc)} меняют у текущей`,
};

/**
 * Причина словами, без точки в конце. Вызывается только для неправимой версии: правимость у
 * каждой полосы своя (множество `EDITABLE` рядом с ней), и это не её вопрос.
 */
export function lockReason(status: DraftState, what: LockObject): string {
  return (
    REASON[status]?.(what) ?? `версия в состоянии «${DRAFT_STATE_LABEL_RU[status]}» не правится`
  );
}
